"use client";

import { Compass } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function HairTreatments() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const quote = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const divider = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const disciplines = [{
    number: "01",
    title: "Recuperación de Densidad",
    description: "Tratamientos avanzados diseñados para revitalizar el folículo y devolver la densidad natural a tu cabello con protocolos médicos personalizados.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/recuperacion_densidad.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/recuperacion_densidad.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/recuperacion_densidad.png-wvc-sizes",
    alt: "Tratamiento de recuperación capilar profesional",
    span: "lg:col-span-5",
    height: "lg:h-[520px]",
    offset: ""
  }, {
    number: "02",
    title: "Fortalecimiento Capilar",
    description: "Nutrición profunda y estimulación biológica para fortalecer la fibra capilar desde la raíz, mejorando la salud y resistencia de tu melena.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/fortalecimiento_capilar.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/fortalecimiento_capilar.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/fortalecimiento_capilar.webp-wvc-sizes",
    alt: "Sesión de fortalecimiento capilar en clínica",
    span: "lg:col-span-4",
    height: "lg:h-[420px]",
    offset: "lg:mt-24"
  }, {
    number: "03",
    title: "Control de Caída",
    description: "Diagnóstico preciso y terapias de vanguardia para frenar la caída excesiva, estabilizando el ciclo de vida del cabello de forma efectiva.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/control_caida.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/control_caida.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/control_caida.png-wvc-sizes",
    alt: "Tratamiento médico para el control de caída",
    span: "lg:col-span-3",
    height: "lg:h-[580px]",
    offset: ""
  }];
  return;
}